<div class="mt-5 mb-16 w-full px-6 py-4 md:px-16">
  <div class="flex flex-col items-stretch gap-10">
    <div class="border-b border-border-secondary pb-6">
      <h1
        class="mt-5 mb-2 bg-gradient-to-b from-gradient-start from-0% via-gradient-middle2 via-50% to-gradient-end to-100% bg-clip-text leading-tight text-transparent"
      >
        {{ 'pages.checkout.title' | translate }}
      </h1>
    </div>

    <div class="flex flex-col gap-2">
      <p>{{ 'pages.checkout.purchase.success' | translate }}</p>
      @if (futureStartDate(); as date) {
        <p>
          {{
            'pages.checkout.purchase.subscriptionPeriod'
              | translate: { date: (date | localizedDate) }
          }}
        </p>
      }
      <p>{{ 'pages.checkout.purchase.redirect' | translate }}</p>
      @if (paymentLink(); as link) {
        <p
          id="redirectLink"
          [innerHTML]="
            'pages.checkout.purchase.redirectLink' | translate: { link }
          "
        ></p>
      }
    </div>
  </div>
</div>
